import "core-js/modules/es6.array.filter.js";
export default {
  props: {
    filter: [String, Object],
    filterMethod: {
      type: Function,
      default: function _default(rows, terms) {
        var cols = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.computedCols;
        var cellValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.getCellValue;
        var lowerTerms = terms ? terms.toLowerCase() : '';
        return rows.filter(function (row) {
          return cols.some(function (col) {
            var val = cellValue(col, row) + '';
            var haystack = val === 'undefined' || val === 'null' ? '' : val.toLowerCase();
            return haystack.indexOf(lowerTerms) !== -1;
          });
        });
      }
    }
  },
  watch: {
    filter: {
      handler: function handler() {
        var _this = this;

        this.$nextTick(function () {
          _this.setPagination({
            page: 1
          }, true);
        });
      },
      deep: true
    }
  }
};